import axios, { dataApi, surveysAPI, pythonApi } from 'config/axios';

/**
 * `persist: false` sets the request headers only, never localStorage: the
 * SIS iframe sign-in keeps its token in memory (utils/lsgoAuthEmbedSession.js).
 */
const setAuthToken = (authToken, { persist = true } = {}) => {
    //Apply on every request
    if (authToken) {
        if (persist) window.localStorage.setItem('authToken', authToken);
        axios.defaults.headers.common['Authorization'] = authToken;
        dataApi.defaults.headers.common['Authorization'] = authToken;
        surveysAPI.defaults.headers.common['Authorization'] = authToken;
        pythonApi.defaults.headers.common['Authorization'] = authToken;
    } else {
        //Delete auth header
        delete axios.defaults.headers.common['Authorization'];
        delete dataApi.defaults.headers.common['Authorization'];
        delete surveysAPI.defaults.headers.common['Authorization'];
        delete pythonApi.defaults.headers.common['Authorization'];
    }
};

export default setAuthToken;
